export default __webpack_public_path__ + "static/media/square.506e4c38.svg";